import React, { useEffect } from 'react';
import s from './UserDataDashboard.module.css';
import { useSelector } from 'react-redux';
import { selectWeeklyStats } from '../../../../store/selectors/dashboardSelectors';
import { useAppDispatch } from '../../../../store/store';
import { fetchWeeklyStats } from '../../../../shared/api/dashboardApi';

export default function UserDataDashboard({
    selectedSocialMedia,
}: {
    selectedSocialMedia: string | null;
}) {
    const weeklyStats = useSelector(selectWeeklyStats);
    const dispatch = useAppDispatch();
    const statsData = [
        {
            value: weeklyStats?.activity_rate ? `${weeklyStats.activity_rate}%` : '0%',
            label: 'Activity rate this week',
        },
        {
            value: weeklyStats?.posts ? `${weeklyStats.posts}/10` : '0/10',
            label: 'Posts made this week',
        },
        {
            value: weeklyStats?.new_followers ? `${weeklyStats.new_followers}` : '0',
            label: 'New followers this week',
        },
    ];

    useEffect(() => {
        if (selectedSocialMedia) {
            const endDate = new Date().toISOString().split('T')[0];
            const startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                .toISOString()
                .split('T')[0];
            dispatch(fetchWeeklyStats({ platform: selectedSocialMedia, startDate, endDate }));
        }
    }, [selectedSocialMedia, dispatch]);

    return (
        <div className={s.container}>
            {statsData.map((stat, index) => (
                <div
                    key={index}
                    className={`${s.card} ${selectedSocialMedia === null ? s.disabled : ''}`}
                >
                    <div className={s.value}>{stat.value}</div>
                    <div className={s.label}>{stat.label}</div>
                </div>
            ))}
        </div>
    );
}
